import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT, IMAGE_ROOT, SUB_DOMAIN} from "../api-config";
import Modal from 'react-responsive-modal';
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

var parse = require('html-react-parser');

class refundPolicy extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            open: false,
            nosessionredirect: false,
            policyTxt: ''
        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        var url = API_ROOT + '/fetchrefundpolicy?sub_domain=' + SUB_DOMAIN;

        this.onOpenModal();
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(policyData => {

                this.onCloseModal();
                if (policyData.status == 1) {
                    this.setState({policyTxt: parse(policyData.policy)});
                }
            });
    };

    componentDidMount() {

        document.title = "Refund Policy - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


    };

    render() {
        const {t} = this.props;
        const {open} = this.state;

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/menu'}></Link>
                        <h2 className="text-center">{t('refund_policy')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35 bp-0 bkg-white full-height m-grey" style={{overflowY:"scroll"}}>
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    {/*<h2 className="text-center font-size-20 m-0">Refund Policy</h2>  */}
                                </div>
                                <div className="header-content help_content" style={{paddingBottom:"50px"}}>

                                    {this.state.policyTxt}
                                </div>

                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false}
                       open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(refundPolicy));


// WEBPACK FOOTER //
// ./src/view_components/refund_policy.js